<template>
  <div id="app">
    <router-view/>
    <notifications position="bottom right" width="50%" />
    <v-dialog/>
  </div>
</template>

<script>
export default {
  name: 'app'
}
</script>

<style>
#app {
  margin: 60px 0 20px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue